import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import PaymentsIcon from '@mui/icons-material/Payments';
import SettingsIcon from '@mui/icons-material/Settings';
import TodayIcon from '@mui/icons-material/Today';
import React from 'react';
import { UserRoles } from '../../enums/userRoles';
import { Navigation } from '../../models/navigation';

import {
  ADMINISTRATION_COMPANIES,
  ADMINISTRATION_MANAGERS,
  ADMINISTRATION_TALENT,
  BULK_UPLOAD,
  CREATE_PAYMENT,
  CREATE_PROJECT,
  DASHBOARD,
  INVOICES,
  PROFILE,
  PROJECTS,
  REPORTING,
  TALENT
} from '../../router/constants';

export const navigation: Navigation[] = [
  {
    id: 1,
    name: 'Dashboard',
    route: DASHBOARD,
    icon: <DashboardIcon />,
    roles: [
      UserRoles.TALENT,
      UserRoles.COMPANY_MANAGER,
      UserRoles.MANAGER,
      UserRoles.ADMIN
    ]
  },
  {
    id: 2,
    name: 'Create Payment',
    route: '',
    icon: <PaymentsIcon />,
    roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN],
    child: [
      {
        id: 1,
        name: 'Quick Payments',
        route: CREATE_PAYMENT,
        roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
      },
      {
        id: 2,
        name: 'Bulk Uploads',
        route: BULK_UPLOAD,
        roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
      }
    ]
  },
  {
    id: 3,
    name: 'Work',
    icon: <AssignmentIcon />,
    roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN],
    route: '',
    child: [
      {
        id: 1,
        name: 'Create a Project',
        route: CREATE_PROJECT,
        roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
      },
      {
        id: 2,
        name: 'View Projects',
        route: PROJECTS,
        roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
      }
    ]
  },
  {
    id: 4,
    name: 'Projects',
    route: PROJECTS,
    roles: [UserRoles.TALENT],
    icon: <AssignmentIcon />
  },
  {
    id: 5,
    name: 'Invoices',
    route: INVOICES,
    icon: <TodayIcon />,
    roles: [
      UserRoles.TALENT,
      UserRoles.COMPANY_MANAGER,
      UserRoles.MANAGER,
      UserRoles.ADMIN
    ]
  },
  {
    id: 6,
    name: 'Reporting',
    route: REPORTING,
    icon: <BarChartIcon />,
    roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
  },
  {
    id: 7,
    name: 'Talent',
    route: TALENT,
    icon: <GroupIcon />,
    roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
  },
  {
    id: 8,
    name: 'Administration',
    route: '',
    icon: <SettingsIcon />,
    roles: [UserRoles.COMPANY_MANAGER, UserRoles.ADMIN],
    child: [
      {
        id: 1,
        name: 'Companies',
        route: ADMINISTRATION_COMPANIES,
        roles: [UserRoles.ADMIN]
      },
      {
        id: 2,
        name: 'Managers',
        route: ADMINISTRATION_MANAGERS,
        roles: [UserRoles.COMPANY_MANAGER, UserRoles.ADMIN]
      },
      {
        id: 3,
        name: 'Talent',
        route: ADMINISTRATION_TALENT,
        roles: [UserRoles.ADMIN]
      }
    ]
  },
  {
    id: 9,
    name: 'Profile',
    route: PROFILE,
    icon: <AccountCircleIcon />,
    roles: [
      UserRoles.TALENT,
      UserRoles.COMPANY_MANAGER,
      UserRoles.MANAGER,
      UserRoles.ADMIN
    ]
  }
  // TODO: Show Library link
  // {
  //   id: 10,
  //   name: 'Library',
  //   route: LIBRARY,
  //   icon: <AccountCircleIcon />,
  //   roles: [UserRoles.COMPANY_MANAGER, UserRoles.MANAGER, UserRoles.ADMIN]
  // }
];
